var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((5),function(item,index){return _c('span',{key:index+1,class:("" + (index < _vm.num ? 'active-star' : 'gray-star') + (_vm.readOnly ? ' read-only' : '')),attrs:{"data-index":index+1},on:{"click":_vm.handleClick}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }